import React from 'react';

/**
 * Relleno visual de mentira para tomar capturas. SOLO en desarrollo.
 *
 * Se dispara con **Ctrl/⌘ + Shift + D** estando en la pantalla. Se eligió un
 * atajo y no un `?demo=1` en la URL porque cuál estimado está abierto vive en
 * memoria, no en la dirección: escribir el parámetro obligaría a recargar y
 * cerraría la pantalla que se quiere fotografiar.
 *
 * Todo vive en el estado de React, así que **recargar lo borra** — que es
 * justo lo que se pidió. Nada toca la base de datos. Pero OJO: con el demo
 * puesto, pulsar «Save» guardaría estas líneas de mentira. Es para mirar, no
 * para guardar.
 *
 * Fuera de desarrollo el atajo ni se registra, así que no hay forma de
 * encenderlo desde la app publicada. Los datos falsos tampoco viajan en el
 * bundle: están en `demoVisualDatos.ts`, que se carga con `import()` dinámico
 * dentro de una rama que el build elimina.
 */
export function useDemoVisualActivo(): boolean {
    const [activo, setActivo] = React.useState(false);

    React.useEffect(() => {
        if (!import.meta.env.DEV) return;
        const alPulsar = (e: KeyboardEvent) => {
            if (e.key !== 'D' && e.key !== 'd') return;
            if (!(e.metaKey || e.ctrlKey) || !e.shiftKey || e.altKey) return;
            // No secuestrar la tecla mientras se escribe.
            const el = e.target as HTMLElement | null;
            if (el) {
                const tag = el.tagName;
                if (tag === 'INPUT' || tag === 'TEXTAREA' || tag === 'SELECT' || el.isContentEditable) return;
            }
            e.preventDefault();
            setActivo(true);
        };
        window.addEventListener('keydown', alPulsar);
        return () => window.removeEventListener('keydown', alPulsar);
    }, []);

    return activo;
}
